import { render } from "./DataCollection.vue?vue&type=template&id=104208e4&scoped=true"
import script from "./DataCollection.vue?vue&type=script&lang=js"
export * from "./DataCollection.vue?vue&type=script&lang=js"

import "./DataCollection.vue?vue&type=style&index=0&id=104208e4&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-104208e4"]])

export default __exports__